import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { Container as ContainerBase } from "components/misc/Layouts.js";
import logo from "../../images/fotodj/cabezagiratoria.png";
import { ReactComponent as InstagramIcon } from "../../images/square-instagram.svg";
import { ReactComponent as YoutubeIcon } from "../../images/youtube-icon.svg";

// Panel estilo etiqueta oscura
const Container = styled(ContainerBase)`
  ${tw`-mx-8 -mb-8 text-gray-100`}
  background: linear-gradient(135deg, #2e2e2e, #1a1a1a);
  border-top: 1px solid #444;
  box-shadow: inset 0 1px 3px rgba(255, 255, 255, 0.05);
  font-family: 'Orbitron', sans-serif;
  letter-spacing: 0.05em;
  text-transform: uppercase;
`;

const Content = tw.div`max-w-screen-xl mx-auto py-16 lg:py-20`;

const Row = tw.div`flex flex-col items-center justify-center text-center px-6`;

const LogoContainer = styled.div`
  ${tw`flex items-center justify-center mb-4`}
`;

const LogoImg = tw.img`w-10`;

const LinksContainer = tw.div`mt-6 font-medium flex flex-wrap justify-center items-center flex-col sm:flex-row text-sm`;

const Link = tw.a`border-b-2 border-transparent hocus:text-gray-300 hocus:border-gray-300 pb-1 transition duration-300 mt-1 mx-4`;

const SocialLinksContainer = tw.div`mt-8 flex justify-center`;

const SocialLink = styled.a`
  ${tw`cursor-pointer inline-block text-gray-100 hover:text-primary-500 transition duration-300 mx-3`}
  svg {
    ${tw`w-5 h-5`}
  }
`;

const Divider = styled.div`
  ${tw`w-full h-px bg-gray-700 my-6`}
`;

const CopyrightText = styled.p`
  ${tw`text-xs text-gray-500 tracking-widest uppercase`}
`;

const HighlightedLink = tw.a`text-primary-500 hover:text-primary-700 transition duration-300`;

const Footer = () => {
  const handleNavClick = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Container>
      <Content>
        <Row>
          <LogoContainer>
            <LogoImg src={logo} alt="Logo" />
          </LogoContainer>

          <LinksContainer>
            <Link onClick={() => handleNavClick("inicio")}>Fotos</Link>
            <Link onClick={() => handleNavClick("blog")}>Videos</Link>
            <Link onClick={() => handleNavClick("sets")}>Sets</Link>
          </LinksContainer>

          <SocialLinksContainer>
            <SocialLink href="https://www.instagram.com/_______rafael__________/" target="_blank" rel="noopener noreferrer">
              <InstagramIcon />
            </SocialLink>
            <SocialLink href="https://www.youtube.com/playlist?list=PLzqs4CUFb2z9IBEH6A5wDc9zHQ3K9nDM_" target="_blank" rel="noopener noreferrer">
              <YoutubeIcon />
            </SocialLink>
          </SocialLinksContainer>

          <Divider />

          <CopyrightText>
            &copy; 2024 Rafael — Web by <HighlightedLink href="https://deltasof.com/">Deltasof</HighlightedLink>
          </CopyrightText>
        </Row>
      </Content>
    </Container>
  );
};

export default Footer;
